var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NcSelect',{staticClass:"group-select",attrs:{"input-id":_vm.setting.id,"placeholder":_vm.t('settings', 'None'),"label":"displayName","options":_vm.availableGroups,"multiple":"","keep-open":""},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})
}
var staticRenderFns = []

export { render, staticRenderFns }